export function findCountryFromCounty(county) {
  let matchingCounty = counties.find(countyItem => countyItem.value === county)
  return matchingCounty ? matchingCounty.group : null
}

export const openingTimesPerMonth = {
  0: ['08:00', '16:30'],
  1: ['07:30', '17:00'],
  2: ['06:30', '18:00'],
  3: ['06:00', '20:00'],
  4: ['05:00', '21:00'],
  5: ['05:00', '21:30'],
  6: ['05:00', '21:30'],
  7: ['06:00', '20:30'],
  8: ['06:30', '19:30'],
  9: ['07:30', '18:00'],
  10: ['07:30', '16:00'],
  11: ['08:00', '16:00']
}

export const countryOptions = [
  {
    value: 'United Kingdom',
    label: 'United Kingdom'
  },
  {
    value: 'England',
    label: 'England'
  },
  {
    value: 'Scotland',
    label: 'Scotland'
  },
  {
    value: 'Wales',
    label: 'Wales'
  },
  {
    value: 'Northern Ireland',
    label: 'Northern Ireland'
  }
]

export const counties = [
  {
    label: 'Bedfordshire',
    value: 'Bedfordshire',
    group: 'England'
  },
  {
    label: 'Berkshire',
    value: 'Berkshire',
    group: 'England'
  },
  {
    label: 'Bristol',
    value: 'Bristol',
    group: 'England'
  },
  {
    label: 'Buckinghamshire',
    value: 'Buckinghamshire',
    group: 'England'
  },
  {
    label: 'Cambridgeshire',
    value: 'Cambridgeshire',
    group: 'England'
  },
  {
    label: 'Cheshire',
    value: 'Cheshire',
    group: 'England'
  },
  {
    label: 'City of London',
    value: 'City of London',
    group: 'England'
  },
  {
    label: 'Cornwall',
    value: 'Cornwall',
    group: 'England'
  },
  {
    label: 'Cumbria',
    value: 'Cumbria',
    group: 'England'
  },
  {
    label: 'Derbyshire',
    value: 'Derbyshire',
    group: 'England'
  },
  {
    label: 'Devon',
    value: 'Devon',
    group: 'England'
  },
  {
    label: 'Dorset',
    value: 'Dorset',
    group: 'England'
  },
  {
    label: 'Durham',
    value: 'Durham',
    group: 'England'
  },
  {
    label: 'East Riding of Yorkshire',
    value: 'East Riding of Yorkshire',
    group: 'England'
  },
  {
    label: 'East Sussex',
    value: 'East Sussex',
    group: 'England'
  },
  {
    label: 'Essex',
    value: 'Essex',
    group: 'England'
  },
  {
    label: 'Gloucestershire',
    value: 'Gloucestershire',
    group: 'England'
  },
  {
    label: 'Greater London',
    value: 'Greater London',
    group: 'England'
  },
  {
    label: 'Greater Manchester',
    value: 'Greater Manchester',
    group: 'England'
  },
  {
    label: 'Hampshire',
    value: 'Hampshire',
    group: 'England'
  },
  {
    label: 'Herefordshire',
    value: 'Herefordshire',
    group: 'England'
  },
  {
    label: 'Hertfordshire',
    value: 'Hertfordshire',
    group: 'England'
  },
  {
    label: 'Isle of Wight',
    value: 'Isle of Wight',
    group: 'England'
  },
  {
    label: 'Kent',
    value: 'Kent',
    group: 'England'
  },
  {
    label: 'Lancashire',
    value: 'Lancashire',
    group: 'England'
  },
  {
    label: 'Leicestershire',
    value: 'Leicestershire',
    group: 'England'
  },
  {
    label: 'Lincolnshire',
    value: 'Lincolnshire',
    group: 'England'
  },
  {
    label: 'Merseyside',
    value: 'Merseyside',
    group: 'England'
  },
  {
    label: 'Norfolk',
    value: 'Norfolk',
    group: 'England'
  },
  {
    label: 'Yorkshire',
    value: 'Yorkshire',
    group: 'England'
  },
  {
    label: 'Northamptonshire',
    value: 'Northamptonshire',
    group: 'England'
  },
  {
    label: 'Northumberland',
    value: 'Northumberland',
    group: 'England'
  },
  {
    label: 'Nottinghamshire',
    value: 'Nottinghamshire',
    group: 'England'
  },
  {
    label: 'Oxfordshire',
    value: 'Oxfordshire',
    group: 'England'
  },
  {
    label: 'Rutland',
    value: 'Rutland',
    group: 'England'
  },
  {
    label: 'Shropshire',
    value: 'Shropshire',
    group: 'England'
  },
  {
    label: 'Somerset',
    value: 'Somerset',
    group: 'England'
  },
  {
    label: 'South Yorkshire',
    value: 'South Yorkshire',
    group: 'England'
  },
  {
    label: 'Staffordshire',
    value: 'Staffordshire',
    group: 'England'
  },
  {
    label: 'Suffolk',
    value: 'Suffolk',
    group: 'England'
  },
  {
    label: 'Surrey',
    value: 'Surrey',
    group: 'England'
  },
  {
    label: 'Tyne and Wear',
    value: 'Tyne and Wear',
    group: 'England'
  },
  {
    label: 'Warwickshire',
    value: 'Warwickshire',
    group: 'England'
  },
  {
    label: 'West Midlands',
    value: 'West Midlands',
    group: 'England'
  },
  {
    label: 'West Sussex',
    value: 'West Sussex',
    group: 'England'
  },
  {
    label: 'West Yorkshire',
    value: 'West Yorkshire',
    group: 'England'
  },
  {
    label: 'Wiltshire',
    value: 'Wiltshire',
    group: 'England'
  },
  {
    label: 'Worcestershire',
    value: 'Worcestershire',
    group: 'England'
  },
  {
    label: 'Anglesey',
    value: 'Anglesey',
    group: 'Wales'
  },
  {
    label: 'Brecknockshire',
    value: 'Brecknockshire',
    group: 'Wales'
  },
  {
    label: 'Caernarfonshire',
    value: 'Caernarfonshire',
    group: 'Wales'
  },
  {
    label: 'Carmarthenshire',
    value: 'Carmarthenshire',
    group: 'Wales'
  },
  {
    label: 'Cardiganshire',
    value: 'Cardiganshire',
    group: 'Wales'
  },
  {
    label: 'Denbighshire',
    value: 'Denbighshire',
    group: 'Wales'
  },
  {
    label: 'Flintshire',
    value: 'Flintshire',
    group: 'Wales'
  },
  {
    label: 'Glamorgan',
    value: 'Glamorgan',
    group: 'Wales'
  },
  {
    label: 'Merioneth',
    value: 'Merioneth',
    group: 'Wales'
  },
  {
    label: 'Monmouthshire',
    value: 'Monmouthshire',
    group: 'Wales'
  },
  {
    label: 'Montgomeryshire',
    value: 'Montgomeryshire',
    group: 'Wales'
  },
  {
    label: 'Pembrokeshire',
    value: 'Pembrokeshire',
    group: 'Wales'
  },
  {
    label: 'Radnorshire',
    value: 'Radnorshire',
    group: 'Wales'
  },
  {
    label: 'Aberdeenshire',
    value: 'Aberdeenshire',
    group: 'Scotland'
  },
  {
    label: 'Angus',
    value: 'Angus',
    group: 'Scotland'
  },
  {
    label: 'Argyllshire',
    value: 'Argyllshire',
    group: 'Scotland'
  },
  {
    label: 'Ayrshire',
    value: 'Ayrshire',
    group: 'Scotland'
  },
  {
    label: 'Banffshire',
    value: 'Banffshire',
    group: 'Scotland'
  },
  {
    label: 'Berwickshire',
    value: 'Berwickshire',
    group: 'Scotland'
  },
  {
    label: 'Buteshire',
    value: 'Buteshire',
    group: 'Scotland'
  },
  {
    label: 'Cromartyshire',
    value: 'Cromartyshire',
    group: 'Scotland'
  },
  {
    label: 'Caithness',
    value: 'Caithness',
    group: 'Scotland'
  },
  {
    label: 'Clackmannanshire',
    value: 'Clackmannanshire',
    group: 'Scotland'
  },
  {
    label: 'Dumfriesshire',
    value: 'Dumfriesshire',
    group: 'Scotland'
  },
  {
    label: 'Dunbartonshire',
    value: 'Dunbartonshire',
    group: 'Scotland'
  },
  {
    label: 'East Lothian',
    value: 'East Lothian',
    group: 'Scotland'
  },
  {
    label: 'Fife',
    value: 'Fife',
    group: 'Scotland'
  },
  {
    label: 'Inverness-shire',
    value: 'Inverness-shire',
    group: 'Scotland'
  },
  {
    label: 'Kincardineshire',
    value: 'Kincardineshire',
    group: 'Scotland'
  },
  {
    label: 'Kinross',
    value: 'Kinross',
    group: 'Scotland'
  },
  {
    label: 'Kirkcudbrightshire',
    value: 'Kirkcudbrightshire',
    group: 'Scotland'
  },
  {
    label: 'Lanarkshire',
    value: 'Lanarkshire',
    group: 'Scotland'
  },
  {
    label: 'Midlothian',
    value: 'Midlothian',
    group: 'Scotland'
  },
  {
    label: 'Morayshire',
    value: 'Morayshire',
    group: 'Scotland'
  },
  {
    label: 'Nairnshire',
    value: 'Nairnshire',
    group: 'Scotland'
  },
  {
    label: 'Orkney',
    value: 'Orkney',
    group: 'Scotland'
  },
  {
    label: 'Peeblesshire',
    value: 'Peeblesshire',
    group: 'Scotland'
  },
  {
    label: 'Perthshire',
    value: 'Perthshire',
    group: 'Scotland'
  },
  {
    label: 'Renfrewshire',
    value: 'Renfrewshire',
    group: 'Scotland'
  },
  {
    label: 'Ross-shire',
    value: 'Ross-shire',
    group: 'Scotland'
  },
  {
    label: 'Roxburghshire',
    value: 'Roxburghshire',
    group: 'Scotland'
  },
  {
    label: 'Selkirkshire',
    value: 'Selkirkshire',
    group: 'Scotland'
  },
  {
    label: 'Shetland',
    value: 'Shetland',
    group: 'Scotland'
  },
  {
    label: 'Stirlingshire',
    value: 'Stirlingshire',
    group: 'Scotland'
  },
  {
    label: 'Sutherland',
    value: 'Sutherland',
    group: 'Scotland'
  },
  {
    label: 'West Lothian',
    value: 'West ',
    group: 'Scotland'
  },
  {
    label: 'Wigtownshire',
    value: 'Wigtownshire',
    group: 'Scotland'
  },
  {
    label: 'Antrim',
    value: 'Antrim',
    group: 'Northern Ireland'
  },
  {
    label: 'Armagh',
    value: 'Armagh',
    group: 'Northern Ireland'
  },
  {
    label: 'Down',
    value: 'Down',
    group: 'Northern Ireland'
  },
  {
    label: 'Fermanagh',
    value: 'Fermanagh',
    group: 'Northern Ireland'
  },
  {
    label: 'Londonderry',
    value: 'Londonderry',
    group: 'Northern Ireland'
  },
  {
    label: 'Tyrone',
    value: 'Tyrone',
    group: 'Northern Ireland'
  }
]
